import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { useSatisfinderAuth } from '@/contexts/SatisfinderAuthContext';

export default function SatisfinderLogin() {
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const { login } = useSatisfinderAuth();
  const [email, setEmail] = useState(sp.get('email') || '');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const r = await login(email, password);
    setSubmitting(false);
    if (r.ok) { nav('/satisfinder/dashboard'); return; }
    if (r.next === 'verify_email') {
      toast.error('Please verify your email first. We sent a fresh code.');
      nav(`/satisfinder/verify-email?email=${encodeURIComponent(email)}`);
      return;
    }
    toast.error(r.error || 'Login failed');
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-6">
      <div className="w-full max-w-md bg-white rounded-2xl border border-[#E2E8F0] p-8 shadow-sm" data-testid="sf-login-form">
        <Link to="/satisfinder" className="flex items-center gap-2">
          <img src="/satisfind-logo.png" alt="satisFIND" style={{ height: 36, width: 'auto' }} />
        </Link>
        <h1 className="font-['Montserrat'] text-2xl font-bold mt-6">Log in to satisFINDER®</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <label className="block">
            <span className="text-xs font-semibold text-[#334155]">Email</span>
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full px-3 py-2.5 border border-[#CBD5E1] rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#1A3E6F]"
              data-testid="sf-login-email" />
          </label>
          <label className="block">
            <span className="text-xs font-semibold text-[#334155]">Password</span>
            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full px-3 py-2.5 border border-[#CBD5E1] rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#1A3E6F]"
              data-testid="sf-login-password" />
          </label>
          <div className="text-right">
            <Link to="/satisfinder/forgot-password" className="text-xs text-[#1A3E6F] hover:underline" data-testid="sf-login-forgot">
              Forgot password?
            </Link>
          </div>
          <button type="submit" disabled={submitting}
            className="w-full bg-[#1A3E6F] hover:bg-[#12305A] disabled:bg-[#94A3B8] text-white font-semibold py-3 rounded-lg text-sm"
            data-testid="sf-login-submit">
            {submitting ? 'Signing in…' : 'Log in'}
          </button>
        </form>
        <p className="text-center text-sm text-[#475569] mt-6">
          New here? <Link to="/satisfinder/signup" className="text-[#1A3E6F] font-semibold hover:underline">Join as a satisFINDER®</Link>
        </p>
      </div>
    </div>
  );
}
